import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const getLandedDashboardSummary = async (monthYear) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const queryString = monthYear ? `?monthYear=${monthYear}` : "";
  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedDashboardSummary}${queryString}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);
    if (response?.ok) {
      return response.json();
    }

    const errorData = response?.json ? await response.json().catch(() => ({})) : {};
    throw new Error(errorData?.message || "Unable to load dashboard summary.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to load dashboard summary.", { contactSupport: false });
    return null;
  }
};

export default getLandedDashboardSummary;
